import { useState } from "react";
import api from "../services/api";

interface UploadResponse {
  url: string;
  key?: string;
  size?: number;
  type?: string;
}

interface UseImageUploadReturn {
  file: File | null;
  setFile: React.Dispatch<React.SetStateAction<File | null>>;
  uploading: boolean;
  uploadImage: (existingImageUrl?: string) => Promise<string>;
}

const useImageUpload = (): UseImageUploadReturn => {
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);

  const uploadImage = async (existingImageUrl: string = ""): Promise<string> => {
    if (!file) return existingImageUrl;

    const formDataObj = new FormData();
    formDataObj.append("image", file);
    setUploading(true);

    try {
      console.log("Uploading file:", file.name);

      const res = await api.post<UploadResponse>(
        "/upload-image",
        formDataObj,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      console.log("Upload response:", res.data);

      setUploading(false);
      setFile(null);
      return res.data.url;
    } catch (err: any) {
      setUploading(false);
      console.error("Image upload failed:", err);
      console.error("Error response:", err.response?.data);
      return "";
    }
  };

  return {
    file,
    setFile,
    uploading,
    uploadImage,
  };
};

export default useImageUpload;
